import classes from './paper.module.css'

// Card renders Paper, so this also sets Card's fill and border.
const Paper = {
  classNames: {
    root: classes.root,
  },
}

export default Paper
